(() => {
  const nav = document.querySelector('[data-jump-nav]');
  if (!nav) return;

  const links = [...nav.querySelectorAll('a.product-scroll-nav__link[href^="#"]')];
  if (links.length === 0) return;

  const idToLink = new Map();
  const sections = [];
  links.forEach((a) => {
    const id = decodeURIComponent(a.getAttribute('href').slice(1));
    if (!id) return;
    const el = document.getElementById(id);
    if (!el) return;
    idToLink.set(id, a);
    sections.push(el);
  });
  if (sections.length === 0) return;

  function setActive(activeId) {
    links.forEach((a) => {
      const href = a.getAttribute('href') || '';
      const id = href.startsWith('#') ? decodeURIComponent(href.slice(1)) : '';
      const on = id === activeId;
      a.classList.toggle('active', on);
      if (on) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  }

  function headerOffset() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    const n = parseInt(raw, 10);
    return Number.isNaN(n) ? 90 : n;
  }

  function syncActive() {
    const mark = window.scrollY + headerOffset() + 32;
    let currentId = sections[0].id;
    for (const sec of sections) {
      const top = sec.getBoundingClientRect().top + window.scrollY;
      if (top <= mark) currentId = sec.id;
    }
    if (idToLink.has(currentId)) setActive(currentId);
  }

  let ticking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        syncActive();
        ticking = false;
      });
    },
    { passive: true }
  );

  window.addEventListener('hashchange', syncActive, { passive: true });
  syncActive();
})();
